/* eslint-disable import/prefer-default-export */
import { dayMap } from './dayMap';
import { dayArray } from './dayArray';

export const getNearestFutureEligibleSessionDate = ({ date, availabilityPlan }) => {
  if (!Array.isArray(availabilityPlan?.entries) || availabilityPlan.entries.length === 0) {
    return null; // No availability plan provided
  }

  const currentDay = date.format('ddd').toLowerCase();
  let eligibleDay = currentDay;
  let hasFoundEligibleDay = false;
  let currentDayAvailability = [];
  let hasBeenOneFullWeek = false;
  while (!hasFoundEligibleDay || !hasBeenOneFullWeek) {
    // eslint-disable-next-line no-loop-func
    currentDayAvailability = availabilityPlan.entries.reduce((availableEntries, entry) => {
      if (entry.dayOfWeek === eligibleDay) {
        availableEntries.push(entry);
      }
      return availableEntries;
    }, []);

    if (currentDayAvailability.length > 0) {
      hasFoundEligibleDay = true;
      break;
    }

    eligibleDay = dayArray[(dayMap[eligibleDay] + 1) % 7]; // Move to next day

    if (eligibleDay === currentDay) {
      // If we looped back to the original day, it means we've checked all days
      hasBeenOneFullWeek = true;
    }
  }

  if (!hasFoundEligibleDay) {
    return null; // No eligible day found in the availability plan
  }

  const eligibleDate =
    eligibleDay === currentDay
      ? {
          date: date.clone(),
          entries: currentDayAvailability,
        }
      : {
          date: date.clone().add((dayMap[eligibleDay] - dayMap[currentDay] + 7) % 7, 'days'),
          entries: currentDayAvailability,
        };

  return eligibleDate;
};
